import { NavigationTabs, type NavigationTabItem } from '@exam-management/components';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const MY_TASK_TAB_ITEMS: NavigationTabItem[] = [
  {
    label: 'Examination Details',
    value: 'task-details',
    path: '/my-task/qset-review/:taskId/subtask/:subTaskId/task-details',
  },
  {
    label: 'Review Result',
    value: 'review-result',
    path: '/my-task/qset-review/:taskId/subtask/:subTaskId/review-result',
  },
];

const TAB_ITEMS: NavigationTabItem[] = [
  {
    label: 'Examination Details',
    value: 'task-details',
    path: '/task-management/qset-review/:taskId/subtask/:subTaskId/task-details',
  },
  {
    label: 'Review Result',
    value: 'review-result',
    path: '/task-management/qset-review/:taskId/subtask/:subTaskId/review-result',
  },
];

export default function QSetReviewSubtaskNavigationTabs() {
  const location = useLocation();
  const tabItems = useMemo(() => {
    if (location.pathname.includes('/my-task')) {
      return MY_TASK_TAB_ITEMS;
    }
    return TAB_ITEMS;
  }, []);
  return <NavigationTabs items={tabItems} navigateOptions={{ replace: true }} />;
}
